import { render, staticRenderFns } from "./ListingsUpgrade.vue?vue&type=template&id=a665bd8c"
import script from "./ListingsUpgrade.vue?vue&type=script&lang=js"
export * from "./ListingsUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports